<template>
    <div>
        <sweet-modal ref="modalAcoesAtivo" title="O que você quer fazer?" blocking>
            <div class="modal-body" v-if="layoutModalAtivo === 0">
                <div class="row">
                <div class="col-4">
                    <button class="btn btn-custom" @click="layoutModalAtivo = 1"><i class="fa fa-plus" style="color: green;"></i> Nova aplicação</button>
                </div>
                <div class="col-4">
                    <button class="btn btn-custom" @click="layoutModalAtivo = 2"><i class="fa fa-minus" style="color: red;"></i> Novo resgate</button>
                </div>
                <div class="col-4">
                    <button class="btn btn-custom" @click="abrirLayoutMovimentos"><i class="fa fa-list" style="color: gray;"></i> Ver movimentos</button>
                </div>
                </div>
            </div>

            <!-- Layout aplicação -->
            <div class="modal-body" v-else-if="layoutModalAtivo === 1">
                <form action="#" data-vv-scope="formulario">
                    <div class="form-group"><!-- Data de Aplicação -->
                        <label class="form-label" for="dataAplicacao">Data da aplicação</label>
                        <vue-pikaday v-model="formularioAtivo.dataAplicacao.value" :options="datePickerOptions"
                            placeholder="Selecione ou digite uma data" v-validate="'dataValida'"
                            class="form-control" :class="{'is-invalid': errors.has('formulario.dataAplicacao')}"
                            name="dataAplicacao" autocomplete="off"
                            :disabled="datePickerOptions.disabled" :key="datePickerOptions.key"
                        />
                        <span v-show="errors.has('formulario.dataAplicacao')" class="invalid-feedback">{{ errors.first('formulario.dataAplicacao') }}</span>
                    </div>
                    <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Valor Aplicado -->
                        <label class="form-label" for="valor aplicado">Valor aplicado</label>
                        <money v-model="formularioAtivo.valorAplicado.value" v-bind="formularioAtivo.valorAplicado.mask" 
                            v-validate="'required|min_value:0.01'" 
                            class="form-control" :class="{'is-invalid': errors.has('formulario.valor aplicado')}" 
                            name="valor aplicado" key="valor aplicado" maxlength="22"
                        >
                        </money>
                        <span v-show="errors.has('formulario.valor aplicado')" class="invalid-feedback">{{ errors.first('formulario.valor aplicado') }}</span>
                    </div>
                </form>
            </div>
            <!-- Fim Layout aplicação -->

            <!-- Layout resgate -->
            <div class="modal-body" v-else-if="layoutModalAtivo === 2">
                <form action="#" data-vv-scope="formulario">
                    <div class="form-group"><!-- Data do resgate -->
                        <label class="form-label" for="dataResgate">Data do resgate</label>
                        <vue-pikaday v-model="formularioAtivo.dataResgate.value" :options="datePickerOptions"
                            placeholder="Selecione ou digite uma data" v-validate="'dataValida'"
                            class="form-control" :class="{'is-invalid': errors.has('formulario.dataResgate')}"
                            name="dataResgate" autocomplete="off"
                            :disabled="datePickerOptions.disabled" :key="datePickerOptions.key"
                        />
                        <span v-show="errors.has('formulario.dataResgate')" class="invalid-feedback">{{ errors.first('formulario.dataResgate') }}</span>
                    </div>
                    <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Valor Aplicado -->
                        <label class="form-label">Saldo do ativo na data</label>
                        <money v-model="formularioAtivo.saldoAtivo.value" v-bind="formularioAtivo.saldoAtivo.mask" class="form-control" :disabled="true"></money>
                    </div>
                    <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Valor Aplicado -->
                        <label class="form-label" for="valor resgatado">Valor resgatado</label>
                        <money v-model="formularioAtivo.valorResgatado.value" v-bind="formularioAtivo.valorResgatado.mask" 
                            v-validate="`required|min_value:0.01|max_value:${this.formularioAtivo.saldoAtivo.value}`" 
                            class="form-control" :class="{'is-invalid': errors.has('formulario.valor resgatado')}" 
                            name="valor resgatado" key="valor resgatado" maxlength="22"
                        >
                        </money>
                        <span v-show="errors.has('formulario.valor resgatado')" class="invalid-feedback">{{ errors.first('formulario.valor aplicado') }}</span>
                    </div>
                </form>
            </div>
            <!-- Fim Layout resgate -->

            <!-- Layout movimentos -->
            <div class="modal-body" v-else-if="layoutModalAtivo === 3">
                <b-table :table-class="'table table-bordered table-hover'" :fields="colunasTabela" :items="linhasMovimentos" thead-class="text-custom primary">
                    <template v-slot:cell(data)="row">
                        <p>{{ formatarData(row.item.data) }}</p>
                    </template>
                    <template v-slot:cell(valor)="row">
                        <p class="coluna-numero">{{ formatarValor(row.item.valor) }}</p>
                    </template>
                    <template v-slot:cell(remover)="row">
                        <span style="cursor: pointer; float: right;"><i class="fa fa-trash" @click="confirmarRemocaoMovimento(row.item)"></i></span>
                    </template>
                </b-table>
            </div>
            <!-- Fim Layout movimentos -->
            <div class="d-flex flex-row justify-content-between mt-4" v-if="layoutModalAtivo !== 0">
                <button type="button" class="btn btn-custom tertiary text-custom secondary" @click="layoutModalAtivo = 0">Voltar</button>
                <button type="button" class="btn btn-custom primary" :disabled="!botaoValido" @click="clickBotao">{{ textoBotao }}</button>
            </div>
        </sweet-modal>

        <sweet-modal ref="modalConfirmarRemocaoMovimento" blocking>
            <div class="modal-body">
                <p>
                    Você tem certeza que deseja excluir o movimento da data {{ formatarData(movimentoParaRemover.data) }}? 
                    Essa operação não poderá ser desfeita e os dados da sua carteira serão atualizados.
                </p>
            </div>
            <div class="d-flex flex-row justify-content-between mt-4">
                <button type="button" class="btn btn-custom tertiary text-custom secondary" @click="$refs.modalConfirmarRemocaoMovimento.close()">Cancelar</button>
                <button type="button" class="btn btn-custom text-danger" @click="removerMovimento()">Remover</button>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import SimuladorService from "@/app/services/Simulador/simulador.service";
import SpinnerService from '../../services/spinner.service';
import UtilsService from '../../services/utils.service';
import moment from 'moment';
import { SweetModal } from "sweet-modal-vue";
import { Money } from 'v-money';

export default {
    components: {
        SweetModal,
        Money
    },
    props: {
        ativo: {
            default: null,
        }
    },
    computed: {
        textoBotao() {
            switch (this.layoutModalAtivo) {
                default:
                case 0:
                    return "Ok";
                case 1:
                    return "Aplicar"
                case 2:
                    return "Resgatar"
                case 3:
                    return "Fechar"
            }
        },
        botaoValido() {
            switch (this.layoutModalAtivo) {
                default:
                case 0:
                    return false;
                case 1:
                    return this.errors.items.length == 0
                        && this.formularioAtivo.dataAplicacao.value != null
                        && this.formularioAtivo.valorAplicado.value > 0
                case 2:
                    return this.errors.items.length == 0
                        && this.formularioAtivo.dataResgate.value != null
                        && this.formularioAtivo.valorResgatado.value > 0
                    return false;
                case 3:
                    return true;
            }
        }
    },
    data() {
        return {
            layoutModalAtivo: 0,
            formularioAtivo: {
                dataAplicacao: {
                    value: null
                },
                valorAplicado: {
                    value: 0,
                    mask: {
                        decimal: ',',
                        thousands: '.',
                        precision: 2,
                        masked: false
                    }
                },
                dataResgate: {
                    value: null
                },
                saldoAtivo: {
                    value: 0,
                    mask: {
                        decimal: ',',
                        thousands: '.',
                        precision: 2,
                        masked: false
                    }
                },
                valorResgatado: {
                    value: 0,
                    mask: {
                        decimal: ',',
                        thousands: '.',
                        precision: 2,
                        masked: false
                    }
                }
            },
            datePickerOptions: { // Configuração do datepicker
                format: "DD/MM/YYYY",
                minDate: null,
                maxDate: null,
                disableWeekends: true,
                disableDayFn(data) {
                    return this.datasInvalidas.includes(moment(data).format('YYYY-MM-DD'))
                },
                i18n: {
                    previousMonth: "Mês anterior",
                    nextMonth: "Próximo mês",
                    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                    weekdaysShort: ["D", "S", "T", "Q", "Q", "S", "S"],
                },
                feriados: [],
                disabled: false,
                key: 1
            },
            colunasTabela: [
                { key: 'data', label: "Data" },
                { key: 'historico', label: "Histórico" },
                { key: 'valor', label: "Valor da movimentação", thClass: "coluna-numero" },
                { key: 'remover', label: "Remover", thClass: "coluna-numero" }
            ],
            linhasMovimentos: [],
            movimentoParaRemover: {
                data: ''
            }
        }
    },
    beforeMount() {
        this.$validator.extend("dataValida", {
            getMessage: `A data selecionada é inválida`,
            validate: (value) => { 
                return !this.datePickerOptions.datasInvalidas.includes(moment(value).format('YYYY-MM-DD'))
            }
        });
        this.obterDatasInvalidas();
    },
    methods: {
        abrir() {
            this.layoutModalAtivo = 0;

            // Resetar veevalidate
            this.$nextTick(() => {
                this.errors.clear();
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            });

            this.$refs.modalAcoesAtivo.open();
        },
        obterDatasInvalidas() {
            this.datePickerOptions.disabled = true
            
            SimuladorService.obterDatasInvalidas().then(resposta => {
                if (resposta.sucesso && resposta.datas) {
                    // O formato precisa vim certo para o pikadate proibir as datas invalidas
                    let datasFormatadas = [];

                    for (let i in resposta.datas) {
                        datasFormatadas.push(moment(resposta.datas[i], "YYYY-MM-DD").format("YYYY-MM-DD"))
                    } 

                    this.datePickerOptions.datasInvalidas = datasFormatadas
                }
                this.datePickerOptions.disabled = false
                this.datePickerOptions.key++
            });
        },
        clickBotao() {
            switch (this.layoutModalAtivo) {
                case 1:
                    this.aplicarAtivo();
                    break;
                case 2:
                    this.resgatarAtivo();
                    break;
                case 3:
                    this.$refs.modalAcoesAtivo.close();
                    break;
            }
        },
        abrirLayoutMovimentos() {
            this.linhasMovimentos = [];
            SpinnerService.show();

            SimuladorService.obterMovimentosAtivo({
                token: this.$route.query.token,
                codigoAtivo: this.ativo.codigoAtivo
            }).then((retorno) => {
                SpinnerService.hide();

                if (retorno.sucesso) {
                    this.linhasMovimentos = retorno.movimentos;

                    // Pode acontecer de o usuário deletar todos os movimentos, logo não tem mais o que a
                    // modal estar aberta
                    if (this.linhasMovimentos.length <= 0) {
                        Vue.notify({
                            title: 'Aviso',
                            type: "alert",
                            group: 'principal',
                            text: "Não existe mais nenhum movimento para este ativo. Re-adicione caso queira visualizar os movimentos.",
                            duration: 5000
                        });

                        this.$refs.modalAcoesAtivo.close();
                    }
                }

                this.layoutModalAtivo = 3
            });
        },
        formatarData(data) {
            return moment(data).format("DD/MM/YYYY");
        },
        formatarValor(numero) {
            return UtilsService.formatNumber(numero);
        },
        confirmarRemocaoMovimento(item){
            this.movimentoParaRemover = item;
            this.$refs.modalConfirmarRemocaoMovimento.open();
        },
        aplicarAtivo() {
            SpinnerService.show();

            SimuladorService.aplicarMovimentoAtivo({
                token: this.$route.query.token,
                codigoAtivo: this.ativo.codigoAtivo,
                dataReferencia: moment(this.formularioAtivo.dataAplicacao.value, "DD/MM/YYYY").format("YYYY-MM-DD"),
                valor: this.formularioAtivo.valorAplicado.value
            }).then((retorno) => {
                SpinnerService.hide();

                if (retorno.sucesso) {
                    Vue.notify({
                        title: 'Sucesso',
                        type: "success",
                        group: 'principal',
                        text: "Movimento aplicado com sucesso.",
                        duration: 5000
                    });
                                    
                    this.$emit('acaoRealizada', { tipo: "movimentoAplicado" });
                    this.$refs.modalAcoesAtivo.close();
                }
            });
        },
        resgatarAtivo() {
            SpinnerService.show();

            SimuladorService.resgatarMovimentoAtivo({
                token: this.$route.query.token,
                codigoAtivo: this.ativo.codigoAtivo,
                dataReferencia: moment(this.formularioAtivo.dataResgate.value, "DD/MM/YYYY").format("YYYY-MM-DD"),
                valor: this.formularioAtivo.valorResgatado.value
            }).then((retorno) => {
                SpinnerService.hide();

                if (retorno.sucesso) {
                    Vue.notify({
                        title: 'Sucesso',
                        type: "success",
                        group: 'principal',
                        text: "Movimento resgatado com sucesso.",
                        duration: 5000
                    });
                                    
                    this.$emit('acaoRealizada', { tipo: "movimentoResgatado" });
                    this.$refs.modalAcoesAtivo.close();
                }
            });
        },
        removerMovimento() {
            this.$refs.modalConfirmarRemocaoMovimento.close();
            SpinnerService.show();

            SimuladorService.removerMovimentoAtivo({
                token: this.$route.query.token,
                codigoAtivo: this.ativo.codigoAtivo,
                numeroControle: this.movimentoParaRemover.numeroControle
            }).then((retorno) => {
                SpinnerService.hide();

                if (retorno.sucesso) {
                    this.movimentoParaRemover = { data: "" };

                    Vue.notify({
                        title: 'Sucesso',
                        type: "success",
                        group: 'principal',
                        text: "Movimento removido com sucesso.",
                        duration: 5000
                    });
                                    
                    this.$emit('acaoRealizada', { tipo: "movimentoRemovido" });
                    this.abrirLayoutMovimentos();
                }
            });
        }
    },
    watch: {
        'formularioAtivo.dataResgate.value': {
            handler(n, o) {
                let data = moment(this.formularioAtivo.dataResgate.value, "DD/MM/YYYY");

                if (data.isValid()) {
                    SimuladorService.obterSaldoAtivoParaData({
                        token: this.$route.query.token,
                        codigoAtivo: this.ativo.codigoAtivo,
                        dataReferencia: data.format("YYYY-MM-DD")
                    }).then((retorno) => {
                        if (retorno.sucesso) {
                            this.formularioAtivo.saldoAtivo.value = retorno.saldo;
                        }
                    });
                }
            },
            deep: true
        }
    }
}
</script>